import { gql } from '@apollo/client';

export const DownloadSoaDocumentTemplateMutation = gql`
    mutation DownloadSoaDocumentTemplate($type: StudentOnlineApplicationDocumentType!) {
        downloadSoaDocumentTemplate(type: $type)
    }
`;
